import ReviewDetail from './review/ReviewDetail';
import PhotoReviewList from './review/PhotoReviewList';
import Write from './review/Write';

/**
 * URL Hash 정보
 * 이 리뷰 모듈은 Hash값을 읽어서 리스트 or 리뷰상세를 보여줍니다. (추후 수정, 쓰기 페이지도 추가 예정)
 * 포토리뷰 리스트 - #photoReview=list
 * 포토리뷰 상세 - #photoReview=review&reviewNo=123123   - 해당 reviewNo를 보여준다.(없을 경우 데어터의 첫번째 리뷰 표시)
 * 다른 서비스에서 링크타고 올 경우 리뷰상세 표시 - #photoReview=review&firstReviewNo=123123
 *  - 링크의 리뷰가 한참 뒤의 데이터인 경우 불러올 방법이 없기 때문에 API에 특정 리뷰No를 같이 넘겨서 해당 리뷰를 첫 데이터로 가져오게 한다.
 *      (이 모듈을 불러오는 베이스 페이지에서 포토리뷰 API에 data로 넘겨서 처리해야한다.)
 *
 * Usesage:

 TMON.oModuleReview.init({
    welContainer: $('#view-default-scene-review-init'), // {jQuery Object} HTML이 들어갈 컨테이너,
    sType: TMON.sDevice === 'PW' ? 'REVIEW' : 'LIST', // {String} 'REVIEW' 리뷰상세보기, 'LIST' 포토리스트, 'MODIFY' 리뷰 수정하기, 'WRITE' 리뷰 쓰기
    bIsSinglePage: true, // {Boolean} 포토리뷰만 있는 페이지인가?(true인 경우 리뷰 페이지를 숨기지 않는다)
    bUseSlider: TMON.sDevice === 'PW' ? false : true, // {boolean} 리뷰상세 보기에서 다음 리뷰로 넘길 때 슬라이더를 사용할것인지? (* PC 또는 단일리뷰를 보여주고 싶을 때 false로 둔다.)
    bShowModifyButtons: false, // {Boolean} 리뷰 삭제, 수정 버튼 노출 여부(모바일의 경우만 해당)
    aReviewList: TMON.oApp.htStorage.photoReviewList.data.list, // {Array} 리뷰 리스트 데이터 (없으면 비워둬도 된다)
    bUseHashEvent: false, // 해쉬로 모드 전환(view, modify, write 등) 가능하게 할것 인가?
    onGetNextData: () => { // 다음 데이터를 가져온다.
        this.getNextPhotoReviewData();
    },
    onRecommend: (nReviewNo, bAlreadyRecommended) => { // 추천하기시
        if (bAlreadyRecommended) { // 이미 추천한 리뷰
            this.cancelRecommendationReview(nReviewNo);
            return;
        }
        this.recommendationReview(nReviewNo);
    },
    onReport: (nReviewNo) => { // 신고하기
        this.openReportReviewLayer(nReviewNo);
    },
    onShow: () => { // 포토리뷰가 보여질 떄
    },
    onHide: () => { // 포토리뷰가 숨겨질 때
    },
    onClickNextReview: () => { // PC의 다음 슬라이드 버튼 클릭시
    },
    onClickPrevReview: () => { // PC의 이전 슬라이드 버튼 클릭시
    },
    onDelete: (nMainBuyNo, nMainDealNo, nMemberNo) => { // 삭제하기
    },
    onModify: (nMainBuyNo, nMainDealNo) => { // 수정하기
    },
    onAddPhoto: (nMainBuyNo, nMainDealNo) => { // 사진추가
    },
    onClickDeal: (sTitle, nDealNo, nReviewNo) => { // 상품 클릭시
    },
    onClickShowOption: () => { // 옵션 펼치기 버튼 클릭시
    },
    onClickPhotoInList: () => { // 포토리스트에서 포토 클릭
    }
});
 */

export default class ModuleReview {
  init(htOptions) {
    const {
      welContainer,
      sType = 'REVIEWDETAIL', // 'LIST', 'REVIEW' (포토리뷰 리스트, 포토리뷰 상세보기)
      onGetNextData, // 다음 데이터를 불러오는 함수
      aReviewList = [], // 처음 받은 리뷰 리스트
    } = htOptions;

    this.onGetNextData = onGetNextData;
    this.aData = aReviewList;
    this.wel = this.render(welContainer);
    this.htOptions = htOptions;

    this.bLoadingNextData = false;
    this.sPrevView = '';
    this.sCurView = '';

    this.setApi();
    this.initPage(sType, Object.assign(htOptions, { welContainer: this.wel }));
    this.setHashChangeEvent();
  }

  setHashChangeEvent() {
    if (this.htOptions.bUseHashEvent !== true) {
      return;
    }

    $(window).on('hashchange', () => {
      this.onChangeHash();
    });

    this.onChangeHash();
  }

  setApi(htApi) {
    this.htApi = {
      getReview: '/api/direct/v1/boardapi/api/review/search/{ReviewNo}',
      write:
        '/api/direct/v1/boardapi/api/review/add/{MainDealSrl}/{MainBuySrl}',
      modify:
        '/api/direct/v1/boardapi/api/review/modify/{ReviewNo}/{MainDealSrl}/{MainBuySrl}',
      getDealInfo: '/api/direct/v1/dealinfoapi/api/deals/list',
      getDealDetailInfo:
        '/api/direct/v1/deliveryapi/api/v2/mypage/users/buys/{MainBuySrl}?useHeader=AN&platform=M_WEB',
      getDeliveryInfo:
        '/api/direct/v1/deliveryapi/api/delivery/getBuyDetailList',
      reviewSurveyItems:
        '/api/direct/v1/boardapi/api/review/survey/info/{mainDealNo}', // 리뷰 평가항목 조회
    };

    if (htApi) {
      this.htApi = Object.assign(this.htApi, htApi);
    }
  }

  getApi() {
    return this.htApi;
  }

  getIsShow() {
    return this.oPhotoReview.bShowed;
  }

  showToast(sText) {
    this.oPhotoReview.showToast(sText);
  }

  addData(aData) {
    this.aData = this.aData.concat(aData);
    this.oPhotoReview.addData(aData);
    this.oPhotoList.addData(aData);
    this.bLoadingNextData = false;
  }

  /**
   * 데이터에서 제거
   * @param nReviewNo
   */
  deleteData(nReviewNo) {
    this.aData.some((htData, nIndex) => {
      if (htData.reviewNo === nReviewNo) {
        this.aData.splice(nIndex, 1);
      }
      return htData.reviewNo === nReviewNo;
    });
  }

  getPrevView() {
    return this.sPrevView;
  }

  /**
   * 다음 데이터를 불러온다.
   */
  getNextData() {
    if (this.bLoadingNextData === true) {
      return;
    }

    if (
      this.onGetNextData !== undefined &&
      typeof this.onGetNextData === 'function'
    ) {
      this.onGetNextData();
      this.bLoadingNextData = true;
    }
  }

  hide() {
    if (this.oPhotoReview) {
      this.oPhotoReview.hide();
    }

    if (this.oPhotoList) {
      this.oPhotoList.hide();
    }
  }

  resetData() {
    this.aData = [];
    if (this.oPhotoReview) {
      this.oPhotoReview.resetData();
    }

    if (this.oPhotoList) {
      this.oPhotoList.resetData();
    }
  }

  afterRecommend(nReviewNo, nRecommendCount, bIsCancelRecommend) {
    for (let i = 0; i < this.aData.length; i += 1) {
      if (this.aData[i].reviewNo === nReviewNo) {
        this.aData[i].isRecommended = !bIsCancelRecommend;
        this.aData[i].recommendCnt = nRecommendCount;
        break;
      }
    }

    if (this.oPhotoReview) {
      this.oPhotoReview.setRecommendCount(
        nReviewNo,
        nRecommendCount,
        bIsCancelRecommend
      );
    }
  }

  onChangeHash() {
    // #photoReview=review&reviewNo=123123
    // #photoReview=review&firstReviewNo=123123
    // #photoReview=list
    // #photoReview=modify&reviewNo=123123
    // #photoReview=write&mainBuySrl=구매번호&mainDealSrl=딜번호
    const htHash = TMON.util.getHashJSON();

    switch (htHash.photoReview) {
      case 'review': // 상세리뷰
        // 로컬스토리지에 저장된 리뷰 ID를 보여준다.
        this.show(
          'review',
          localStorage.getItem('FIRST_REVIEW_ACTION_SERIAL')
            ? localStorage.getItem('FIRST_REVIEW_ACTION_SERIAL')
            : parseInt(htHash.reviewNo, 10)
        );
        break;
      case 'list': // 포토리뷰 리스트
        this.show('list');
        break;
      case 'modify':
        this.show('modify', parseInt(htHash.reviewNo, 10));
        break;
      case 'write':
        this.show(
          'write',
          null,
          parseInt(htHash.mainBuySrl, 10),
          parseInt(htHash.mainDealSrl, 10)
        );
        break;
      default:
        this.hideAll();
        break;
    }
  }

  show(sType, sReviewNo, sDealType, sReviewType) {
    this.sPrevView = this.sCurView; // 리뷰보기에서 수정 페이지로 넘어 갔을때 수정완료 후 이전의 리뷰보기 페이지로 넘어가기 위해 view를 저장해 둔다.
    this.sCurView = sType;

    // 리뷰가 수정되어 업데이트 중이면 기다렸다 실행한다.
    if (this.bIsReviewUpdateNow === true) {
      this.sTypeAfterUpdate = sType;
      this.sReviewNoAfterUpdate = sReviewNo;
      return;
    }

    switch (sType) {
      case 'list':
        this.oWrite.hide();
        this.oPhotoReview.hide();
        this.oPhotoList.show();
        break;
      case 'review':
        this.oWrite.hide();
        this.oPhotoList.hide();
        this.oPhotoReview.show(sReviewNo);
        break;
      case 'modify':
        this.oWrite.show(true, sReviewNo);
        break;
      case 'write':
        this.oWrite.show(false, sReviewNo, sDealType, sReviewType);
        break;
      default:
        break;
    }

    this.onShow(sType);
  }

  onShow(sType) {
    if (typeof this.htOptions.onShow === 'function') {
      this.htOptions.onShow(sType);
    }
  }

  reset() {
    this.sPrevView = '';
    this.sCurView = '';
  }

  hideAll() {
    if (this.htOptions.bIsSinglePage === true) {
      return;
    }

    if (typeof this.htOptions.onHide === 'function') {
      this.htOptions.onHide();
    }

    this.oPhotoReview.hide();
    this.oPhotoList.hide();
    this.oWrite.hide();
    this.reset();
  }

  initPage(sType, htOptions) {
    this.oPhotoReview = new ReviewDetail(htOptions, this);
    this.oPhotoList = new PhotoReviewList(htOptions, this);
    this.oWrite = new Write(htOptions, this);
  }

  getData() {
    return this.aData;
  }

  render(welContainer) {
    const sHtml = '<div class="_moduleContainer"></div>';
    return welContainer.html(sHtml);
  }

  updateData(sReviewNo, htData) {
    for (let i = 0; i < this.aData.length; i += 1) {
      if (this.aData[i].reviewNo === parseInt(sReviewNo, 10)) {
        this.aData[i] = htData;
        break;
      }
    }
  }

  getReviewUpdate(sReviewNo) {
    this.bIsReviewUpdateNow = true;
    $.ajax({
      url: this.htApi.getReview.replace('{ReviewNo}', sReviewNo),
      data: {
        useHeader: TMON.bLogin ? 'MN' : '',
        useDealInfo: false,
      },
      success: res => {
        this.bIsReviewUpdateNow = false;
        if (!res || !res.data) {
          return;
        }

        // 리뷰 상세를 보여줄때 렌더링을 새로 하도록 플래그를 추가한다.
        res.data.bIsUpdated = true; // eslint-disable-line no-param-reassign

        this.updateData(sReviewNo, res.data);
        if (this.sTypeAfterUpdate) {
          this.show(this.sTypeAfterUpdate, this.sReviewNoAfterUpdate);
        }

        this.sTypeAfterUpdate = null;
        this.sReviewNoAfterUpdate = null;
      },
    });
  }

  deleteReviewFromModuleList(nReviewNo) {
    this.deleteData(parseInt(nReviewNo, 10));
    if (this.oPhotoList) {
      this.oPhotoList.removeItem(nReviewNo);
    }

    if (this.oPhotoReview) {
      this.oPhotoReview.removeItem(nReviewNo);
    }

    // 마지막 데이터가 삭제 되었을 경우
    if (this.getData().length === 0) {
      if (typeof this.htOptions.onAfterDeleteLastData === 'function') {
        this.htOptions.onAfterDeleteLastData();
      }
    }
  }
}

TMON.oModuleReview = new ModuleReview();
